import React from 'react';
import { useParams } from "react-router";

import Chat from "../../components/Chat/Chat"

const CoachChat: React.FC = () => {
  const { coachId } = useParams();

  return (
    <div className="main-content">
      <div className="rounded" style={{height: "calc(100dvh - 200px)"}}>
        <Chat isCoach={false} coachId={coachId}/>
      </div>
    </div>
  );
};

export default CoachChat;
